import { ReactNode, useState } from 'react'
import { AnalyticsHeaderSlotContext } from './AnalyticsHeaderSlotContext'

// Provider component to wrap the application
export function AnalyticsHeaderSlotProvider({
    children,
}: {
    children: ReactNode
}) {
    const [slot, setSlot] = useState<ReactNode>(null)

    return (
        <AnalyticsHeaderSlotContext.Provider value={{ slot, setSlot }}>
            {children}
        </AnalyticsHeaderSlotContext.Provider>
    )
}
